// Add your JS customizations here
window.initACFMaps = function () {
  const maps = document.querySelectorAll('.acf-map');

  maps.forEach(mapEl => {
    const lat  = parseFloat(mapEl.dataset.lat);
    const lng  = parseFloat(mapEl.dataset.lng);
    const zoom = parseInt(mapEl.dataset.zoom) || 15;

    const map = new google.maps.Map(mapEl, {
      center: { lat, lng },
      zoom,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false
    });

    new google.maps.Marker({
      position: { lat, lng },
      map
    });
  });
};


function equalizeCarouselText() {
    const items = document.querySelectorAll('.carousel-item');
    const titles = document.querySelectorAll('.carousel-item .title');
    const descs = document.querySelectorAll('.carousel-item .text_content');

    if (!items.length) return;

    // Temporarily show all slides so their content can be measured
    items.forEach(item => item.classList.add('measuring'));

    let maxTitleHeight = 0;
    let maxDescHeight = 0;

    // Reset heights before measuring
    titles.forEach(el => el.style.height = '');
    descs.forEach(el => el.style.height = '');

    // Measure tallest title
    titles.forEach(el => {
        maxTitleHeight = Math.max(maxTitleHeight, el.offsetHeight);
    });

    // Measure tallest text_content
    descs.forEach(el => {
        maxDescHeight = Math.max(maxDescHeight, el.offsetHeight);
    });

    // Apply equal heights
    titles.forEach(el => el.style.height = maxTitleHeight + 'px');
    descs.forEach(el => el.style.height = maxDescHeight + 'px');

    // Remove measuring class so Bootstrap carousel works normally
    items.forEach(item => item.classList.remove('measuring'));
}

// Run after images load + on resize
window.addEventListener('load', equalizeCarouselText);
window.addEventListener('resize', equalizeCarouselText);

function initSyncedCarousel(imgSelector, textSelector, nextBtnSelector, prevBtnSelector) {
	const imgCarouselEl = document.querySelector(imgSelector);
	const textCarouselEl = document.querySelector(textSelector);

	if (!imgCarouselEl || !textCarouselEl) return;

    // Initialize carousels
	const imgCarousel = new understrap.Carousel(imgCarouselEl, { interval: 10000, ride: 'carousel' });
	const textCarousel = new understrap.Carousel(textCarouselEl, { interval: 10000, ride: 'carousel' });

	let syncing = false;

    // Sync function
	function syncCarousel(targetCarousel, e) {
		if (syncing) return;
		syncing = true;
		targetCarousel.to(e.to);
		syncing = false;
	}

	imgCarouselEl.addEventListener('slide.bs.carousel', e => syncCarousel(textCarousel, e));
	textCarouselEl.addEventListener('slide.bs.carousel', e => syncCarousel(imgCarousel, e));

    // Custom next/prev buttons
	const nextBtn = document.querySelector(nextBtnSelector);
	const prevBtn = document.querySelector(prevBtnSelector);

	if (nextBtn) nextBtn.addEventListener('click', () => imgCarousel.next());
	if (prevBtn) prevBtn.addEventListener('click', () => imgCarousel.prev());

    // Adjust text heights
	equalizeCarouselText();
	window.addEventListener('resize', equalizeCarouselText);
}

document.addEventListener('DOMContentLoaded', function () {

	new SlimSelect({
    	select: '#cat',
    	settings: {
		    placeholderText: 'Category',
		    showSearch: false,
	  	}
  	});

  	new SlimSelect({
    	select: '#archives-dropdown-2',
    	settings: {
		    placeholderText: 'Archives',
		    showSearch: false,
	  	}
  	});

	const navItems = document.querySelectorAll("#main_nav .pb_sub");
    const submenus = document.querySelectorAll(".sub_menu");
    let timeout;

    // Helper to get submenu from href
    function getSubmenu(selector) {
        if (selector) {
	        return document.querySelector(selector);
	    }
	    return null;
    }

    // Show submenu with fade
    function showSubmenu(submenu, item) {
        submenus.forEach(sm => sm.classList.remove("active"));
        navItems.forEach(ni => ni.classList.remove("active"));

        submenu.classList.add("active");
        item.classList.add("active");
    }

    // Hide submenu with fade
    function hideSubmenu(submenu, item) {
        submenu.classList.remove("active");
        item.classList.remove("active");
    }

    navItems.forEach(item => {
        const link = item.querySelector("a");

        // prevent click navigation
	    link.addEventListener("click", (e) => {
	        e.preventDefault();
	    });

        item.addEventListener("mouseenter", () => {
	        const selector = link.dataset.submenu;
	        const submenu = getSubmenu(selector);

	        if (submenu) {
	            clearTimeout(timeout);
	            showSubmenu(submenu, item);
	        }
	    });

        item.addEventListener("mouseleave", () => {
	        const selector = link.dataset.submenu;
	        const submenu = getSubmenu(selector);

	        if (submenu) {
	            timeout = setTimeout(() => {
	                hideSubmenu(submenu, item);
	            }, 300);
	        }
	    });
    });

    submenus.forEach(submenu => {
        submenu.addEventListener("mouseenter", () => {
            clearTimeout(timeout); // Prevent hiding while hovering submenu
        });

        submenu.addEventListener("mouseleave", () => {
            const submenuId = submenu.id;
            const menuItem = document.querySelector(`#main_nav .pb_sub a[data-submenu="#${submenuId}"]`).parentElement;

            timeout = setTimeout(() => {
                hideSubmenu(submenu, menuItem);
            }, 300);
        });
    });

    document.querySelectorAll('#pb_menu .has_sub').forEach(item => {
	    item.addEventListener('click', function (e) {
	        e.preventDefault(); // stops jumping to anchor
	        const target = this.getAttribute('href');

	        if (target && target.length > 0) {
	            const el = document.querySelector(target);
	            if (el) {
	                el.classList.add('active');
	            }
	        }
	    });
	});

	document.querySelectorAll('.close_sub_menu').forEach(item => {
	    item.addEventListener('click', function (e) {
	        e.preventDefault();

	        const target = this.getAttribute('href'); // e.g. "#submenu1"

	        if (!target) return;

	        const el = document.querySelector(target);
	        if (el) {
	            el.classList.remove('active');
	        }
	    });
	});

	const mainNav = document.querySelector('#main_nav');
	const bookDesktop = document.querySelector('#fixed_book_desktop');
	const bookMobile = document.querySelector('#fixed_book_mobile');

	function toggleScrolled() {
		if (window.scrollY > 50) {
			if (mainNav) mainNav.classList.add('scrolled');
			if (bookDesktop) bookDesktop.classList.add('scrolled');
			if (bookMobile) bookMobile.classList.add('scrolled');
			document.body.classList.add('scrolled');
		} else {
			if (mainNav) mainNav.classList.remove('scrolled');
			if (bookDesktop) bookDesktop.classList.remove('scrolled');
			if (bookMobile) bookMobile.classList.remove('scrolled');
			document.body.classList.remove('scrolled');
		}
	}

	let ticking = false;
	window.addEventListener('scroll', function () {
		if (!ticking) {
			window.requestAnimationFrame(function () {
				toggleScrolled();
				ticking = false;
			});
			ticking = true;
		}
	});

	toggleScrolled();

	document.getElementById('nav_toggle').addEventListener('click', function () {
		document.body.classList.toggle('menu_open');
		document.body.classList.remove('search_open');
		document.querySelectorAll('.sub_menu.active').forEach(el => {
	        el.classList.remove('active');
	    });
	});

	document.getElementById('search_toggle').addEventListener('click', function (e) {
		e.preventDefault();
		document.body.classList.toggle('search_open');
		document.body.classList.remove('menu_open');
		document.querySelectorAll('.sub_menu.active').forEach(el => {
	        el.classList.remove('active');
	    });
	});

	document.getElementById('close_search').addEventListener('click', function (e) {
		e.preventDefault();
		document.body.classList.remove('search_open');
	});

	// custom cursor on content area
	const area = document.getElementById('content');
	const cursor = document.getElementById('pb_cursor');

	if (area && cursor) {
		area.addEventListener('mouseenter', () => {
			cursor.style.display = 'block';
		});

		area.addEventListener('mouseleave', () => {
			cursor.style.display = 'none';
		});

		area.addEventListener('mousemove', e => {
			const rect = area.getBoundingClientRect();
			cursor.style.left = e.clientX - rect.left + 'px';
			cursor.style.top = e.clientY - rect.top + 'px';
		});
	}

	document.querySelectorAll('.explicit_off').forEach(btn => {
	    btn.addEventListener('click', () => {
	        document.querySelectorAll('.explicit').forEach(el => {
	            el.classList.add('off');
	        });
	    });
	});

	// News carousel

	document.querySelectorAll('.rtl_carousel').forEach(function (el) {
        var splide = new Splide(el, {
            type: 'loop',
            perPage: 2,
            pagination: false,
            direction: 'rtl',
            breakpoints: {
                575: { perPage: 1 },
            },
        });
        splide.mount();
    });

    // download carousel

    const downloads = document.querySelectorAll('#downloads');

    downloads.forEach(wrapper => {
        const splideEl = wrapper.querySelector('.splide');
        const prevBtn  = wrapper.querySelector('.download_prev');
        const nextBtn  = wrapper.querySelector('.download_next');

        const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
	    const perPage = 3;

	    const splide = new Splide(splideEl, {
	        type: slidesCount > perPage ? 'loop' : 'slide', // <-- only loop if enough slides
	        perPage: perPage,
	        perMove: 1,
	        arrows: false,
	        pagination: false,
	        breakpoints: {
	            575: { perPage: 1 },
	        },
	    });

	    splide.mount();

        // External controls
        if (prevBtn) { prevBtn.addEventListener('click', () => splide.go('<')); }
        if (nextBtn) { nextBtn.addEventListener('click', () => splide.go('>')); }
    });

    document.querySelectorAll('.gallery_navigation a[href^="#"]').forEach(anchor => {
	  anchor.addEventListener('click', function(e) {
	    const target = document.querySelector(this.getAttribute('href'));
	    if (!target) return; // skip if target doesn't exist

	    e.preventDefault(); // prevent default jump
	    target.scrollIntoView({
	      behavior: 'smooth',
	      block: 'start' // respects scroll-margin-top
	    });
	  });
	});

    // Galleries carousel

	document.querySelectorAll('.gallery_carousel_wrap').forEach(function (wrap) {

	    const splideEl = wrap.querySelector('.gallery_carousel');
	    const prevBtn  = wrap.querySelector('.splide__arrow--prev');
	    const nextBtn  = wrap.querySelector('.splide__arrow--next');

	    const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
	    const perPage = 3;

	    const splide = new Splide(splideEl, {
	        type: slidesCount > perPage ? 'loop' : 'slide', // <-- only loop if enough slides
	        perPage: perPage,
	        perMove: 1,
	        arrows: false,
	        pagination: false,
	        breakpoints: {
	            575: { perPage: 1 },
	        },
	    });

	    splide.mount();

	    // Bind controls to this specific instance
	    if (prevBtn) { prevBtn.addEventListener('click', () => splide.go('<')); }
	    if (nextBtn) { nextBtn.addEventListener('click', () => splide.go('>')); }

	});

	const galleryWrappers = document.querySelectorAll('.single_gallery_wrapper');

	galleryWrappers.forEach(wrapper => {
	    const mainEl = wrapper.querySelector('.single_gallery_carousel .splide');
	    if (!mainEl) return;

	    const mainSlides = mainEl.querySelectorAll('.splide__slide').length;
	    const mainLoop = mainSlides > 2;

	    const mainSplide = new Splide(mainEl, {
	        type: mainLoop ? 'loop' : 'slide',
	        perPage: 1,
	        focus: 'center',
	        speed: 300,
	        perMove: 1,
	        arrows: false,
	        pagination: false,
	        rewind: true, // ensures arrows always work
	        breakpoints: { 
	        	575: {
		            perPage: 1,
		        },
	        },
	    }).mount();

	    // Thumbnail carousel
	    const thumbEl = wrapper.querySelector('.single_thumbnail_carousel .splide');
	    if (!thumbEl) return;

	    const thumbSlides = thumbEl.querySelectorAll('.splide__slide').length;
	    const thumbLoop = thumbSlides > 2;

	    const thumbSplide = new Splide(thumbEl, {
	        type: thumbLoop ? 'loop' : 'slide',
	        perPage: 5,
	        focus: 'center',
	        speed: 300,
	        perMove: 1,
	        arrows: false,
	        pagination: false,
	        isNavigation: true,
	        rewind: true,
	        breakpoints: { 
	        	575: {
		            perPage: 3,
		            gap: '16px',
		            focus: 'center',
		        },
		        992: {
		            gap: 0,    // desktop uses margins instead
		            focus: 'center',
		        },
	        },
	    }).mount();

	    mainSplide.sync(thumbSplide);

	    // --- Single external controls ---
	    const prevBtn = wrapper.querySelector('.single_gallery_prev');
	    const nextBtn = wrapper.querySelector('.single_gallery_next');

	    prevBtn?.addEventListener('click', () => mainSplide.go('<'));
	    nextBtn?.addEventListener('click', () => mainSplide.go('>'));

	    // --- Ensure clones stay dimmed during transitions ---
	    mainSplide.on(['mounted', 'move'], () => {
	        const clones = thumbEl.querySelectorAll('.splide__slide--clone img');
	        clones.forEach(img => img.style.opacity = 0.1);
	    });
	});

    // synced carousels

	initSyncedCarousel('#highlights_text_carousel', '#highlights_image_carousel', '.highlight_next', '.highlight_prev');

	document.querySelectorAll('.logo-carousel-wrapper').forEach(wrapper => {
		const track = wrapper.querySelector('.logo-carousel-track');
		const items = Array.from(track.children);
		const logosPerView = parseInt(wrapper.dataset.logosPerView) || 5;

		// -----------------------------
		// Clone items to create seamless loop
		// -----------------------------
		for (let i = 0; i < 2; i++) {
			items.forEach(item => track.appendChild(item.cloneNode(true)));
		}

		let offset = 0;
		let speed = 0.5; // pixels per frame
		let requestId;
		let trackWidth;

		// -----------------------------
		// Set item widths and initial positions
		// -----------------------------
		const setWidths = () => {
			const width = wrapper.offsetWidth / logosPerView;
			track.querySelectorAll('.logo-item').forEach(el => {
				el.style.flex = `0 0 ${width}px`;
			});
			trackWidth = track.scrollWidth / 3; // width of one original set
			offset = -trackWidth;                // start at middle set for seamless loop
			track.style.transform = `translate3d(${offset}px,0,0)`;
		};
		setWidths();
		window.addEventListener('resize', setWidths);

		// -----------------------------
		// Auto-scroll using transform
		// -----------------------------
		const animate = () => {
			offset -= speed;

			// Loop seamlessly
			if (offset <= -trackWidth * 2) {
				offset += trackWidth;
			}

			track.style.transform = `translate3d(${offset}px,0,0)`;
			requestId = requestAnimationFrame(animate);
		};
		requestId = requestAnimationFrame(animate);

		// -----------------------------
		// Pause on hover (desktop only)
		// -----------------------------
		wrapper.addEventListener('mouseenter', () => cancelAnimationFrame(requestId));
		wrapper.addEventListener('mouseleave', () => requestId = requestAnimationFrame(animate));

		// -----------------------------
		// Arrow controls (smooth scroll)
		// -----------------------------
		const id = wrapper.id;

		const smoothScroll = (delta, onComplete) => {
			const startOffset = offset;
			const endOffset = startOffset + delta;
			const duration = 300;
			const startTime = performance.now();

			const step = (now) => {
				const t = Math.min((now - startTime) / duration, 1);
				const eased = t < 0.5 ? 2*t*t : -1 + (4 - 2*t)*t;
				offset = startOffset + (endOffset - startOffset) * eased;
				track.style.transform = `translate3d(${offset}px,0,0)`;

				if (t < 1) {
					requestAnimationFrame(step);
				} else {
					if (typeof onComplete === "function") onComplete();
				}
			};
			requestAnimationFrame(step);
		};

		document.querySelectorAll(`[data-carousel-target="${id}"]`).forEach(btn => {
			btn.addEventListener('click', () => {
				cancelAnimationFrame(requestId); // pause autoplay
				const dir = btn.classList.contains('left') ? 1 : -1; // inverted because transform moves opposite
				const moveBy = wrapper.offsetWidth / logosPerView;
				smoothScroll(dir * moveBy, () => {
					requestId = requestAnimationFrame(animate); // resume autoplay
				});
			});
		});
	});

	// parallax

	const parallaxDivs = document.querySelectorAll('.parallax');
	const contentBlocks = document.querySelectorAll('.content_block');
	const leftSide = document.querySelector('.left_side');

	if (parallaxDivs.length > 0) {

		// Function to set left-side height = width (square) and sync content block heights
		function setHeights() {
			const width = leftSide.offsetWidth;
			leftSide.style.height = `${width}px`;

			contentBlocks.forEach(block => {
				block.style.height = `${width}px`;
			});
		}

		// Initial setup and update on resize
		window.addEventListener('load', setHeights);
		window.addEventListener('resize', setHeights);

		// Show first image initially
	
		parallaxDivs[0].classList.add('active');
		parallaxDivs[0].style.backgroundImage = `url(${parallaxDivs[0].dataset.image})`;


		function getScrollOffset() {
		  	// Example: 120px max, scale down for narrow screens
			const vw = window.innerWidth;
			const vh = window.innerHeight;

		 	// scale offset relative to viewport width (optional)
		  	// you can tweak this formula
			const offset = Math.min(240, vw * 0.1); 
			return offset;
		}

		// Swap images on scroll
		window.addEventListener('scroll', () => {
			const scrollTop = window.scrollY;
			const offset = getScrollOffset();

			contentBlocks.forEach((block, index) => {
				const blockTop = block.offsetTop - offset;
				const blockBottom = blockTop + block.offsetHeight;

				if (scrollTop >= blockTop && scrollTop < blockBottom) {
					parallaxDivs.forEach(d => d.classList.remove('active'));
					parallaxDivs[index].classList.add('active');
					parallaxDivs[index].style.backgroundImage = `url(${parallaxDivs[index].dataset.image})`;
				}
			});
		});

		window.addEventListener('resize', getScrollOffset);

	}



	const para1 = document.getElementsByClassName('para1');
	const para2 = document.getElementsByClassName('para2');
	const para3 = document.getElementsByClassName('para3');
	const para3up = document.getElementsByClassName('para3up');
	const para3down = document.getElementsByClassName('para3down');
	const para4 = document.getElementsByClassName('para4');
	const para5 = document.getElementsByClassName('para5');
	//if ($(window).width() > 992) {
	new simpleParallax(para1, {
		//delay: .25,
		orientation: 'down',
		scale: 1.5,
		overflow: true,
		//transition: 'cubic-bezier(0,0,0,1)',
	});
	new simpleParallax(para2, {
		//delay: .25,
		orientation: 'up',
		scale: 1.5,
		overflow: true,
		//transition: 'cubic-bezier(0,0,0,1)',
	});
	new simpleParallax(para3, {
		//delay: .25,
		orientation: 'down',
		scale: 1.2,
		overflow: false,
		//transition: 'cubic-bezier(0,0,0,1)',
	});
	new simpleParallax(para3up, {
		//delay: .25,
		orientation: 'up',
		scale: 1.1,
		overflow: false,
		//transition: 'cubic-bezier(0,0,0,1)',
	});
	new simpleParallax(para3down, {
		//delay: .25,
		orientation: 'down',
		scale: 1.1,
		overflow: false,
		//transition: 'cubic-bezier(0,0,0,1)',
	});
	new simpleParallax(para4, {
		//delay: .25,
		orientation: 'down',
		scale: 1.25,
		overflow: true,
		//transition: 'cubic-bezier(0,0,0,1)',
	});
	new simpleParallax(para5, {
		//delay: .25,
		orientation: 'up',
		scale: 1.25,
		overflow: true,
		//transition: 'cubic-bezier(0,0,0,1)',
	});

	// stop video on change

	var videos_carousel = document.getElementById('videos_carousel');

	if (videos_carousel) {

		videos_carousel.addEventListener('slide.bs.carousel', function (e) {
		    const active = e.relatedTarget; // the slide we're going to
		    const allSlides = document.querySelectorAll('#videos_carousel .carousel-item');

		    allSlides.forEach(slide => {
		        if (slide !== active) {
		            const iframe = slide.querySelector('iframe');
		            if (iframe) {
		                const src = iframe.src;
		                iframe.src = '';
		                iframe.src = src;
		            }
		        }
		    });
		});

	}

	const loadbtn = document.getElementById('loadMoreTreatments');
	  if (!loadbtn) return;

	  loadbtn.addEventListener('click', function () {
	    const hiddenItems = Array.from(document.querySelectorAll('.mobile-hidden'));
	    const limit = document.querySelector('.limit-trigger');
	    if (hiddenItems.length === 0) return;

	    hiddenItems.forEach(el => {
	      el.classList.remove('mobile-hidden');
	      void el.offsetWidth; // force reflow
	      el.classList.add('mobile-visible');
	    });

	    // Properly hide your button without conflicting with Bootstrap display classes
	    loadbtn.classList.add('d-none'); // preferred over style.display
	    limit.classList.remove('overlay_fade');
	  });

	const loadProdbtn = document.getElementById('loadMoreProducts');
	  if (!loadProdbtn) return;

	  loadProdbtn.addEventListener('click', function () {
	    const hiddenItems = Array.from(document.querySelectorAll('.mp-mobile-hidden'));
	    const limit = document.querySelector('.mp-limit-trigger');
	    if (hiddenItems.length === 0) return;

	    hiddenItems.forEach(el => {
	      el.classList.remove('mp-mobile-hidden');
	      void el.offsetWidth; // force reflow
	      el.classList.add('mp-mobile-visible');
	    });

	    // Properly hide your button without conflicting with Bootstrap display classes
	    loadProdbtn.classList.add('d-none'); // preferred over style.display
	    limit.classList.remove('overlay_fade');
	  });

});

const promo = document.getElementById("pb_promo");
const promo_cta = document.getElementById("promo_cta");
const dismiss = document.getElementById("dismiss_promo");

if (promo) {

  	// Check if session cookie exists
  	const isDismissed = sessionStorage.getItem("promoDismissed") === "true";

  	if (!isDismissed) {

    	const onScroll = function () {
      		const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      		const scrollTop = window.scrollY || document.documentElement.scrollTop;
      		const scrollPercent = (scrollTop / scrollHeight) * 100;

      		if (scrollPercent >= 20) {
      			document.body.classList.add('promo_active');
        		promo.classList.add("active");
        		document.removeEventListener("scroll", onScroll);
      		}	
    	};

    	document.addEventListener("scroll", onScroll);

    	if (dismiss) {
      		dismiss.addEventListener("click", function () {
      			document.body.classList.remove("promo_active");
    			promo.classList.remove("active");
        		sessionStorage.setItem("promoDismissed", "true"); // mark as dismissed
        		document.removeEventListener("scroll", onScroll);
      		});
		}

		if (promo_cta) {
      		promo_cta.addEventListener("click", function () {
      			document.body.classList.remove("promo_active");
    			promo.classList.remove("active");
        		sessionStorage.setItem("promoDismissed", "true"); // mark as dismissed
        		document.removeEventListener("scroll", onScroll);
      		});
		}

  	} else {
    	// Already dismissed this session, hide promo
    	document.body.classList.remove("promo_active");
    	promo.classList.remove("active");
  	}
}
